// extracted by mini-css-extract-plugin
export default {"desktop":"style_desktop__cyb1h","mobile":"style_mobile__wgGQ+","laptop":"style_laptop__+88I5"};